import React from 'react';
import { QEnvs } from './_graphql/queries';

const withEnvs = Component => {
  return function WithEnv (props) {
    return (
      <QEnvs>
        {({ envs }) => {
          const envsToObject = JSON.parse(envs);
          return <Component {...props} env={envsToObject}/>;
        }}
      </QEnvs>
    );
  };
};

export default withEnvs;
